module.exports = __webpack_public_path__ + "static/img/COC2021-14.af79e18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-14.jpg
// module id = Rt14
// module chunks = 0